import Reveal from "@/components/Reveal";

const WORSHIP_IMG = "https://images.unsplash.com/photo-1490730141103-6cac27aaab94?q=80&w=1400&auto=format&fit=crop";

const chapters = [
  {
    n: "01",
    title: "Exponer a las personas a Jesús",
    text: "Existimos para que cada persona que cruce nuestra puerta pueda encontrarse con una relación viva y real con Jesús. No una religión: una relación.",
  },
  {
    n: "02",
    title: "Amar, imitar y servir",
    text: "Creemos que la fe se demuestra en lo cotidiano: amando sin condición, imitando a Cristo en casa y en el trabajo, y sirviendo a nuestra comunidad de Toluca.",
  },
  {
    n: "03",
    title: "Hablar de Él a otros",
    text: "La gracia que recibimos no se guarda. Somos una familia que anuncia con su vida —y con sus palabras— la esperanza que encontró.",
  },
];

const Manifesto = () => (
  <section id="quienes-somos" className="relative overflow-hidden bg-ink py-28 lg:py-40" data-testid="manifesto-section">
    <span className="vertical-label absolute left-5 top-32 hidden text-[10px] font-light uppercase tracking-[0.5em] text-paper/30 xl:block" data-testid="manifesto-vertical-label">
      Manifiesto
    </span>

    <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="mb-8 flex items-center gap-4 text-[10px] font-light uppercase tracking-[0.5em] text-fire" data-testid="manifesto-eyebrow">
              <span className="inline-block h-px w-16 bg-fire" /> Quiénes somos
            </p>
            <h2 className="font-serif text-5xl leading-[0.95] tracking-tight text-paper sm:text-7xl" data-testid="manifesto-title">
              Una familia que vive de la <em className="italic text-gold">gracia</em>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <blockquote
              className="mt-14 text-base font-light leading-relaxed tracking-wide text-paper/70 md:columns-2 md:gap-12 md:text-lg"
              data-testid="manifesto-quote"
            >
              <span className="mb-4 block font-serif text-6xl leading-none text-fire">«</span>
              Somos una iglesia que existe para ayudar a las personas a estar expuestas a una relación con Jesús:
              amar, imitar, servir y hablar a otros de Él. Esa es nuestra misión — ni más ni menos. Creemos en una fe
              que se respira, que se mueve como el viento y que transforma lo cotidiano de nuestra ciudad.
            </blockquote>
          </Reveal>

          <div className="mt-10">
            {chapters.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1}>
                <div className="group relative border-t border-white/10 py-12 transition-colors duration-500 hover:bg-surface" data-testid={`manifesto-chapter-${c.n}`}>
                  <span className="outline-text pointer-events-none absolute -top-6 right-0 select-none font-serif text-[7rem] leading-none lg:text-[9rem]">
                    {c.n}
                  </span>
                  <div className="relative grid gap-4 pr-24 md:grid-cols-[1fr_2fr]">
                    <h3 className="font-serif text-2xl leading-snug text-paper md:text-3xl">{c.title}</h3>
                    <p className="max-w-lg text-sm font-light leading-relaxed tracking-wide text-smoke">{c.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="relative lg:col-span-4 lg:col-start-9">
          <Reveal delay={0.25} className="lg:sticky lg:top-32">
            <div className="absolute -inset-6 bg-fire/20 blur-3xl" aria-hidden="true" />
            <figure className="relative border border-white/10">
              <img src={WORSHIP_IMG} alt="Persona con brazos abiertos en adoración frente al atardecer" className="aspect-[3/4] w-full object-cover" />
              <figcaption className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-ink/90 to-transparent p-6 text-[10px] font-light uppercase tracking-[0.3em] text-paper/70">
                En Su presencia
              </figcaption>
            </figure>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Manifesto;
